import { render, staticRenderFns } from "./EmployeeLeaveBenefits.vue?vue&type=template&id=1e672488"
import script from "./EmployeeLeaveBenefits.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveBenefits.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveBenefits.vue?vue&type=style&index=0&id=1e672488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports